/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseModuleUpgradePreviewResponseData } from './genericApiResponseModuleUpgradePreviewResponseData';
import type { GenericApiResponseModuleUpgradePreviewResponseMessage } from './genericApiResponseModuleUpgradePreviewResponseMessage';
import type { GenericApiResponseModuleUpgradePreviewResponsePagination } from './genericApiResponseModuleUpgradePreviewResponsePagination';
import type { GenericApiResponseModuleUpgradePreviewResponseError } from './genericApiResponseModuleUpgradePreviewResponseError';

export interface GenericApiResponseModuleUpgradePreviewResponse {
  data?: GenericApiResponseModuleUpgradePreviewResponseData;
  message?: GenericApiResponseModuleUpgradePreviewResponseMessage;
  pagination?: GenericApiResponseModuleUpgradePreviewResponsePagination;
  error?: GenericApiResponseModuleUpgradePreviewResponseError;
  statusCode?: number;
}
